const colors = {
    white: '#FFFFFF',
    black: '#000000',
    red: '#B72929',
    gray: '#4D4D4D',
}

export default colors